<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="课程信息"
      table-max-height="535px"
      expand-all-row
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.courseList"
      @on-reset="onResetQuery"
      :default-sort="{ prop: 'UpdateTime', order: 'descending' }"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="课程名称" label-width="120px">
          <el-input
            v-model="params.GoodsName"
            placeholder="请输入课程名称"
            clearable
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="GoodsName" label="课程名称" min-width="300px" />
        <el-table-column prop="RealityBrowse" label="点击数" min-width="82px" />
        <el-table-column prop="VirtuallySales" label="播放数" min-width="82px" />
        <el-table-column prop="SaleAmount" label="合计金额" min-width="82px" >
          <template slot-scope="{row}">
            <el-link  type="primary" @click="toOrder(row)">{{row.SaleAmount}}</el-link>
          </template>
        </el-table-column>

        <template v-if="isMallGoods">
          <el-table-column prop="GoodsCover" label="封面图" min-width="82px">
            <template slot-scope="{ row }">
              <el-image
                v-if="row.GoodsCover"
                style="width: 60px; height: 60px"
                :src="'/api' + row.GoodsCover"
                fit="contain"
                :preview-src-list="['/api' + row.GoodsCover]"
              ></el-image>
              <span v-else>暂无图片</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="DistributionPrice" label="分销价" min-width="100px" /> -->

          <el-table-column
            prop="OriginalPrice"
            label="原价"
            min-width="100px"
          />
          <el-table-column
            prop="PlatformPrice"
            label="销售价"
            min-width="100px"
          />

          <el-table-column
            prop="SaleState"
            label="上/下架状态"
            width="100px"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.SaleState == 1" type="success">上架</el-tag>
              <el-tag v-if="row.SaleState == 0" type="danger">下架</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="GroundingTime"
            label="最后上架时间"
            width="160px"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.GroundingTime">{{ row.GroundingTime }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="OffshelfTime"
            label="最后下架时间"
            width="120px"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.OffshelfTime">{{
                $commonJs.toDateString(row.OffshelfTime)
              }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="UpdateTime"
            label="更新时间"
            width="160px"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.UpdateTime">{{ row.UpdateTime }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="IfHot"
            label="是否热卖"
            width="100px"
            align="center"
            v-if="loginInfo.UserType == 0"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfHot == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfHot == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="IfRecommend"
            label="是否爆款"
            width="100px"
            align="center"
            v-if="loginInfo.UserType == 0"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfRecommend == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfRecommend == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="IfNew"
            label="是否新品"
            width="100px"
            align="center"
            v-if="loginInfo.UserType == 0"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfNew == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfNew == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            prop="State"
            label="状态"
            width="80px"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.State == 0" type="danger">停用</el-tag>
              <el-tag v-else type="success">启用</el-tag>
            </template>
          </el-table-column>
        </template>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <list-Dialog ref="listDialog" @close-saved="reload"></list-Dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import listDialog from "./listDialog";
export default {
  mixins: [listMixin],
  components: { list,listDialog },
  props: {
    isMallGoods: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/goods/info").default,
      brand_api: require("@/api/goods/brand").default,
      typeplatform_api: require("@/api/goods/typeplatform").default,

      params: {
        GoodsName: "", //名称
        BrandId: null, //品牌

        State: null, //状态 - 0：停用，1：正常
        //  SaleState: null, //上下架状态 - 0：下架，1：上架
        TradeMode: 1,
        FilingsOrderids: "", //对应的保税商品备案序号
        FilingsNames: "", //对应的保税商品备案名称
        IsMonth: null,
        IsNewStyle: null,
      },
      Brands: [],
      TypePlatforms: [],
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),

      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.brand_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    });
    this.typeplatform_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
  },
  methods: {
    toOrder(row){
      this.$refs.listDialog.open().then(that=>{
        that.params.GoodsId=row.RecordId;
        that.getData(that.params);
      });
    },
    sortChange(column, prop, order) {
      console.log(column, prop, order);
    },
    onTreeSelect(t) {
      if (!t) {
        this.params.TypeplatformIdChain = null;
      } else {
        this.params.TypeplatformIdChain = t.IdChain;
      }
    },
    onResetQuery() {
      console.log("onResetQuery", this.params);
      if (this.$refs.picker1) this.$refs.picker1.clear();
      if (this.$refs.picker2) this.$refs.picker2.clear();
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateSaleState(data) {
      this.api.updateSaleState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateRecommendState(data) {
      this.api.updateRecommendState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateHotState(data) {
      this.api.updateHotState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateNewState(data) {
      this.api.updateNewState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>